var VoxelManagerEnum;
(function (VoxelManagerEnum) {
    VoxelManagerEnum["RLE"] = "RLE";
    VoxelManagerEnum["Volume"] = "Volume";
})(VoxelManagerEnum || (VoxelManagerEnum = {}));
export default VoxelManagerEnum;
